//import OrderDetails from "./OrderDetails/OrderDetails"
import OrderDetails from "./OrderDraftDetails/OrderDetails"

export default function OrderList ({
  orders,
  shipModals,
  updateOrderData,
  updateSbOrderData,
  showRefreshButton = true,
  showOpportunityButton = true
}) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', paddingBottom: '10px' }}>
      {orders.map((o,i) => {
        const key = (o.dataSb ? 'sb_' + (o.dataSb.id || i) : o.data._id || i)
        return (
          <OrderDetails 
            key={key} 
            orderEx={o} 
            shipModals={shipModals}
            updateOrderData={updateOrderData} 
            updateSbOrderData={updateSbOrderData} 
            showRefreshButton={showRefreshButton} 
            showOpportunityButton={showOpportunityButton} />
        )
      })}
    </div>
  )
}